import apirecebimentoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('recebimento/produtor', { params: { ...where, ...params } }),
        apirecebimentoweb.get('recebimento/count/produtor', { params: where }),
      ]);
      return { data, total };
    },

    async count(_, { where } = {}) {
      const { data } = await apirecebimentoweb.get('recebimento/count/produtor', { params: where });
      return Number(data.count);
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apirecebimentoweb.get('recebimento/produtor');
      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apirecebimentoweb.get(`recebimento/produtor/${id}`);
      return data;
    },

    // async findResumo(context, { where }) {
    //   const { data } = await apirecebimentoweb.get('recebimento/resumo', { params: where });
    //   return data;
    // },

    async findResumo(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('recebimento/resumo/produtor', { params: { ...where, ...params } }),
        apirecebimentoweb.get('recebimento/countresumo/produtor', { params: where }),
      ]);
      return { data, total };
    },

    async getAll(context) {
      if (context.state.currentrecebimento) {
        return context.state.currentrecebimento;
      }
      const response = await apirecebimentoweb.get('/recebimento/produtor');
      context.commit('SET_CURRENT_RECEBIMENTO', response.data);
      return response.data;
    },

    async findDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('recebimento/distinct/produtor', { params: where }),
      ]);
      return data;
    },

    async findDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`recebimento/distinct/produtor/${codigo}`),
      ]);
      return { data };
    },

    async findDistinctPropriedade(_, { where } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('recebimento/distinct/produtor/propriedade', { params: where }),
      ]);
      return data;
    },

    async filtroRecebimentoCardProdutor(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('/recebimento/filtro/produtor', { params: where }),
      ]);
      return { data };
    },

    async filtroRecebimentoCardProdutorCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`recebimento/filtro/produtor/${codigo}`),
      ]);
      return { data };
    },

  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },

  },
};
